import styled from 'styled-components/macro';
import { ellipsis } from 'polished';

const SnoozeName = styled.span`
  ${ellipsis('320px')}
  max-height: 20px;
`;

export default SnoozeName;
